import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import {
  Label,
  Panel,
} from '@printdeal/ui-library';
import { AlternativeUpload, IAlternativeUpload } from '@printdeal/alternative-upload';

interface AttachmentsProps {
  alternativeUploadHandler: (uploads: IAlternativeUpload[]) => void;
}

const Attachments = ({ alternativeUploadHandler }: AttachmentsProps) => {
  const { register } = useFormContext();

  return (
    <>
      <Label>
        <FormattedMessage id="account.quotes.form.header.attachment" defaultMessage="Add examples" />
      </Label>

      <Panel>
        <input type="hidden" id="attachment" {...register('attachment')} />
        <AlternativeUpload
          id="quote-attachments"
          name="quote-attachments"
          onChange={alternativeUploadHandler}
          maxFiles={2}
          dataLayerData={{ location: 'quote_attachments' }}
        />
      </Panel>

      <p className="pd-text-sm pd-text-dim-500">
        <FormattedMessage id="account.quotes.form.helptext.attachment" defaultMessage="(Optional)" />
      </p>
    </>
  );
};

export default Attachments;
